<div class="dashboard">


     <div class="row">
        <div class="col-md-3">
            <div class="custom-card">
                <div class="profile">
                    <div class="icon"><i class="fa fa-user-o" aria-hidden="true" style="color: #ffff;"></i></div>
                    <label class="title-label">Total bookings </label>
                </div>
                <div class="analytics">
                    <div class="data">
                        <label class="data-label">{{total_booking}}</label>
                    </div>
                    <div class="percentage">
                        <!-- <label class="text-success" *ngIf="dashboardAnalyticsPercentage['totalPetRegistered']>=0">+{{dashboardAnalyticsPercentage['totalPetRegistered']}}%</label>
                        <label class="text-danger" *ngIf="dashboardAnalyticsPercentage['totalPetRegistered']<0">-{{dashboardAnalyticsPercentage['totalPetRegistered']}}%</label> -->
                        <label>This month</label>
                    </div>
                </div>
               
            </div> 
        </div>
        <div class="col-md-3">
            <div class="custom-card">
                <div class="profile">
                    <div class="icon"><i class="fa fa-money" aria-hidden="true" style="color: #ffff;"></i></div>
                    <label class="title-label">Today's Collection</label>
                </div>
                <div class="analytics">
                    <div class="data">
                        <!-- <label class="data-label">₹ {{totalAmountOfCurrentDate}}</label> -->
                    </div>
                    <div class="percentage">
                        <!-- <label class="text-success" *ngIf="dashboardAnalyticsPercentage['todayCollection']>=0">+{{dashboardAnalyticsPercentage['todayCollection']}}%</label>
                        <label class="text-danger" *ngIf="dashboardAnalyticsPercentage['todayCollection']<0">-{{dashboardAnalyticsPercentage['todayCollection']}}%</label> -->
                        <label>This month</label>
                    </div>
                </div>
                <!-- <div class="view">
                    <label>View All -></label>
                </div> -->
            </div>
        </div>
        <div class="col-md-3">
            <div class="custom-card">
                <div class="profile">
                    <div class="icon"><i class="fa fa-credit-card" aria-hidden="true" style="color: #ffff;"></i></div>
                    <label class="title-label">Total Earning 
                        till Date</label>
                </div>
                <div class="analytics">
                    <div class="data">
                        <!-- <label class="data-label">₹ {{pendingAmount}}</label> -->
                    </div>
                    <div class="percentage">
                        <!-- <label class="text-success" *ngIf="dashboardAnalyticsPercentage['pendingPayment']>=0">+{{dashboardAnalyticsPercentage['pendingPayment']}}%</label>
                        <label class="text-danger" *ngIf="dashboardAnalyticsPercentage['pendingPayment']<0">-{{dashboardAnalyticsPercentage['pendingPayment']}}%</label> -->
                        <label>This month</label>
                    </div>
                </div>
                <!-- <div class="view">
                    <label>View All -></label>
                </div> -->
            </div>
        </div>
        <div class="col-md-3">
            <div class="custom-card">
                <div class="profile">
                    <div class="icon"><i class="fa fa-calendar" aria-hidden="true" style="color: #ffff;"></i></div>
                    <label class="title-label">Refund
                        Payments</label>
                </div>
                <div class="analytics">
                    <div class="data">
                        <!-- <label class="data-label">₹ {{totalEarning}}</label> -->
                    </div>
                    <div class="percentage">
                        <!-- <label class="text-success" *ngIf="dashboardAnalyticsPercentage['totalEarningTillDate']>=0">+{{dashboardAnalyticsPercentage['totalEarningTillDate']}}%</label>
                        <label class="text-danger" *ngIf="dashboardAnalyticsPercentage['totalEarningTillDate']<0">-{{dashboardAnalyticsPercentage['totalEarningTillDate']}}%</label> -->
                        <label>This month</label>
                    </div>
                </div>
                <!-- <div class="view">
                    <label>View All -></label>
                </div> -->
            </div>
        </div>

     </div>









    <div class="charts">
        <div class="chart">
            <label class="chart-title">Total bookings</label>
            <!-- <h6>Total : {{noOfPet}}</h6> -->

            <ngx-charts-pie-chart  *ngIf="pieChartData && pieChartData.length > 0" [view]="[500, 400]" [scheme]="colorScheme1" [results]="pieChartData"
                [legend]="showLegend" [explodeSlices]="explodeSlices" [labels]="showLabels" [doughnut]="doughnut"
                [gradient]="gradient"></ngx-charts-pie-chart>

        </div>
        <div class="chart">
            <ngx-charts-line-chart [view]="view2" [results]="lineChartData" [legend]="showLegend" [xAxis]="showXAxis"
                [yAxis]="showYAxis" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
                [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" [autoScale]="autoScale"
                (select)="onSelect2($event)">
            </ngx-charts-line-chart>
        </div>
    </div>

</div>


<ngx-spinner type="ball-atom">
    <p style="color: white"> Loading... </p>
  </ngx-spinner>